import { render, staticRenderFns } from "./OrganizationalTree.vue?vue&type=template&id=33e6c2c2&"
import script from "./OrganizationalTree.vue?vue&type=script&lang=js&"
export * from "./OrganizationalTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports